export const REDUCER_NAME='socailMediaslice';

export interface iSocialMediaDTO {
    link?: string;
    name?: string;

}

export interface iSocialMedia{
    id: string; 
    link?: string;
    name?: string;

  
}

export interface iSocialMediaState {
      socialMediaList: iSocialMedia[] | null;
      isLoading: boolean;
      errorMessage: string | null;
  }
  